(function ( $ ) {
    (function () {
        $(".icon-font-search.submit").click(function () {
            $(".page-search-form").submit();
        });
        $(".search-input").keyup(function () {
            let searchQuery = $(this).val();
            $(".search-input").val(searchQuery);
            let token = $('meta[name="csrf-token"]').attr('content');
            // console.log(searchQuery);
            if (searchQuery.length >= 3) {
                $(".header-search .spinner").show();
                axios
                    .post(`/ajax/search`, {
                        search_query: searchQuery,
                    }, {
                        headers: {
                            'X-CSRF-TOKEN': token
                        }
                    })
                    .then(resp => {
                        // console.log(response.data);
                        let pathArray = window.location.pathname.split('/');
                        const lang = pathArray[1];

                        if ( resp.data.result.length) {
                            $('.search_result').html("<ul class=\"p-3\"></ul>");
                            $('.search_result').show();
                        } else {
                            $('.search_result').html("");
                            $('.search_result').hide();
                        }

                        let BreakException = {};

                        try {
                            resp.data.result.forEach((item, index) => {
                                let price = !isNaN(item.price) ? new Intl.NumberFormat('ua-UA', { maximumFractionDigits: 0 , useGrouping: true }).format(item.price) + " грн" : "";
                                let title = ( lang !== "ua" ) ? item.title_ru : item.title_ua;
                                title = title.length > 75  ? title.slice(0,75) + " ..." : title;
                                let show_btn_text = ( lang !== "ua" ) ? "Показать все" : "Показати все";
                                let url = ( lang !== "ua" ) ? item.url : "/ua/" + item.url;
                                if (index < 5) {
                                    $('.search_result ul').append(
                                        "<li>\n" +
                                        "   <a href=\"" + url + "\" >\n" +
                                        ((item.img !== undefined ) ? "      <div class=\"search-result-info\">\n" +
                                        "      <img src='" + item.img +"' alt='photo'>\n" +
                                        "      </div>\n" : "")+
                                        "      <div class=\"search-result-info flex-grow-1\">\n" +
                                        "         <div>" + title + "</div>\n" +
                                        "      </div>\n" +
                                        ((price) ? "      <div class=\"search-result-price\">" + price + "</div>\n" : "") +
                                        "   </a>\n" +
                                        "</li>\n");
                                    if (index < 4 ) {
                                        $('.search_result ul').append(
                                            "<hr>");
                                    }
                                } else {
                                    $('.search_result ul').append(
                                        "<li>\n" +
                                        "   <a class=\"search-btn show-all-btn\">" + show_btn_text +"</a>\n" +
                                        "</li>");
                                    $(".show-all-btn").click(function () {
                                        $(".js_search_form").submit();
                                    });
                                    throw BreakException;
                                }
                            });
                        } catch (e) {
                            if (e !== BreakException) throw e;
                        }
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        $(".header-search .spinner").hide();
                    });
            }
        });

        $(window).click(function() {
            if ($(".search_result").is(":visible")) {
                $('.search_result').hide();
            }
        });

        $('.search_result').click(function(event){
            event.stopPropagation();
        });

        $('.header .icon-font-search').click(function() {
            if ($(".js_search_form").hasClass("d-flex")) {
                $('.js_search_form').removeClass("d-flex");
            } else {
                $('.js_search_form').addClass("d-flex");
            }
        });

    }());

}( jQuery ));
